/**
 * @param  {string} str Date to validate
 * @param {boolean} reverseDateMonth Whether to reverse the date to the current chart
 * @return {Date} Validated Date
 */
const validateDate = (str, reverseDateMonth) => {
  if (!reverseDateMonth) return new Date(str);
  const [day, month, year] = str.split('/');
  return new Date(`${month}/${day}/${year}`);
};

export default validateDate;
